// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3_FvH","heading":"YVHiQ","subHeading":"_1TTn6"};